import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryComputePreviewDto } from "../dto/battery-proposal-compute.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/** As the equipment preview: the gateway keeps PowurOS inputs for 30 minutes. */
const PREVIEW_STALE_TIME_MS = 30_000

/** The AI compute nodes PowurOS offers the proposal, with what each would earn. Side-effect free. */
export default function useBatteryComputePreview(
  proposalId: string | undefined,
  options?: { enabled?: boolean },
): UseQueryResult<BatteryComputePreviewDto, unknown> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.computePreview(proposalId ?? ``),
    queryFn: ({ signal }) =>
      batteryProposalService.previewCompute(proposalId ?? ``, signal),
    enabled: Boolean(proposalId) && (options?.enabled ?? true),
    staleTime: PREVIEW_STALE_TIME_MS,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
